export default "__VITE_ASSET__22DltZ5A__"